/* eslint-disable react-hooks/exhaustive-deps */
// src/context/IdContext.js
import { createContext, useContext, useEffect, useMemo, useState, useCallback } from "react";
import { useAuth } from "./AuthContext";
import { db } from "../firebase/config";
import { collection, documentId, getCountFromServer, getDocs,limit,orderBy,query, Timestamp, where, } from "firebase/firestore";

const chunk = (arr, size = 10) => Array.from({ length: Math.ceil(arr.length / size) }, (_, i) => arr.slice(i * size, i * size + size));
const toJsDate = (d) => (typeof d?.toDate === "function" ? d.toDate() : (d ? new Date(d) : null));


const VariableContext = createContext(null);
VariableContext.displayName = "VariableContext";

// Helpers arriba (no se “caen” por hoisting)
const toDate = (v) =>
  typeof v?.toDate === "function" ? v.toDate() : v ? new Date(v) : null;
const toMs = (v) => toDate(v)?.getTime?.() ?? 0;

export const VariableProvider = ({ children }) => {
  const { user } = useAuth();
  const [ newLoad, setNewLoad ] = useState(false);
  const [ idItem, setIdItem ] = useState(null);
  const [ route, setRoute ] = useState(null);
  const [ isRegisterOpen, setIsRegisterOpen ] = useState(false);
  const [ selectedIndex, setSelectedIndex ] = useState(0);
  const [ orderPictures, setOrderPictures ] = useState([]);
  const [ isModalOpen, setIsModalOpen ] = useState(false);
  const [ currentPage, setCurrentPage ] = useState(1);
  // ---- Data / control ----
  const [ error, setError ] = useState(null);
  const [ usersList, setUsersList] = useState([]);
  const [ dataUsers , setDataUsers ] = useState([])
  const [ companys, setCompanys ] = useState([]);
  const [ shouldReload, setShouldReload]  = useState(0);
  const [ load, setLoad ] = useState(true);
  const [ users, setUsers ] = useState([]);
  const [ usersCount, setUsersCount]= useState(0);
  const [ userOrders, setUserOrders ] = useState([]);
  const [ userOrdersLoaded, setUserOrdersLoaded ] = useState(false);
  const [ userAsingKit, setUserAsingKit ] = useState([]);
  const [ userAsingKitLoaded, setUserAsingKitLoaded ] = useState(false);
  const [ alarms, setAlarms ] = useState([]);
  const [ connectedLast30Days, setConnectedLast30Days ] = useState(0);
  const [ tips, setTips ] = useState([]);
  const [ sCount, setSCount ] = useState(0); // Sillas
  const [ eCount, setECount ] = useState(0); // Escritorios
  const [ cCount, setCCount ] = useState(0); // Computadores (2 categorías)
  const [ aCount, setACount ] = useState(0); // Otros
  const [ oCount, setOCoun ] = useState(0); // Otros
  const [ orderKpis, setOrderKpis] = useState({
      verif:   { count: 0, latest: null },  // 0
      prep:    { count: 0, latest: null },  // 1,2
      route:   { count: 0, latest: null },  // 3,4,5
      deliv:   { count: 0, latest: null },  // 6
      pickup:  { count: 0, latest: null },  // 7..14
  });
  // Estado para el mes actual y su porcentaje de rotación
  const [ month, setMonth ] = useState({ datos: [], porcentaje: "0" });
  const [ chartSize, setChartSize ] = useState({ prope: 150, inner: 60, outer: 70 });
  // fuera del componente
  const US_ROLES = ["US-001", "US-002","US-003","US-004","US-005"]
  const SA_ROLES = ["SA-001","SA-002","SA-003","SA-004","SA-005"];
  const AA_ROLES = ["AA-001","AA-002","AA-003"];
  const TIP_FUNCS = ["training","tips"];
  // distribucion por ROL
  const isSA = useMemo(() => SA_ROLES.includes(user?.rol), [user?.rol]);
  const isAA = useMemo(() => AA_ROLES.includes(user?.rol), [user?.rol]);
  const isUU = useMemo(() => US_ROLES.includes(user?.rol), [user?.rol]);
  // contador de tareas de arranque
  const [bootPending, setBootPending] = useState(0);
  const incBoot = useCallback(() => setBootPending(x => x + 1), []);
  const decBoot = useCallback(() => setBootPending(x => Math.max(0, x - 1)), []);
  // eslint-disable-next-line no-unused-vars
  const bootDone = bootPending === 0;
  // Informacion de dasboard
  // ------ Data de Notificaciones del usuario ------//
  useEffect(() => {
    let alive = true;
    if (!user?.idc && !isSA) return;
    incBoot();
    (async () => {
      try {
        const baseCol = collection(db, "notification_alert");
        const roleFilters = [];
        if (isAA) roleFilters.push(where("idc", "==", user.idc));
        if (isUU) roleFilters.push(where("idu", "==", user.id));

        const qTips   = query(baseCol, ...roleFilters, where("functions","in", TIP_FUNCS), orderBy("date","desc"), limit(30));
        const qRecent = query(baseCol, ...roleFilters, orderBy("date","desc"), limit(60));

        const [snTips, snRecent] = await Promise.all([ getDocs(qTips), getDocs(qRecent) ]);
        const rawTips   = snTips.docs.map(d => ({ id: d.id, ...d.data(), date: toJsDate(d.data()?.date) }));
        const rawRecent = snRecent.docs.map(d => ({ id: d.id, ...d.data(), date: toJsDate(d.data()?.date) }));
        const alertsRaw = rawRecent.filter(x => !TIP_FUNCS.includes(x.functions || ""));

        // cargar solo los usuarios necesarios
        const uniqueIdus = Array.from(new Set([...rawTips, ...alertsRaw].map(x => x.idu).filter(Boolean)));
        const userMap = new Map();
        if (uniqueIdus.length) {
          const usersCol = collection(db, "users");
          const chunksArr = chunk(uniqueIdus, 10);
          const snaps = await Promise.all(chunksArr.map(ids => getDocs(query(usersCol, where(documentId(), "in", ids)))));
          snaps.forEach(snap => snap.forEach(docu => userMap.set(docu.id, docu.data())));
        }

        const enrich = (x) => {
          const udata = userMap.get(x.idu) || {};
          return {
            id: x.id,
            idu: x.idu ?? "",
            idc: x.idc ?? "",
            affair: x.affair ?? "",
            date: x.date ?? null,
            message: x.message ?? "",
            functions: x.functions ?? "",
            route: x.route ?? "/",
            status: x.status ?? false,
            nombre: udata?.nombre || "",
            apellido: udata?.apellido || "",
            img: udata?.img || "",
          };
        };

        if (!alive) return;
        setTips(rawTips.map(enrich));
        setAlarms(
          alertsRaw
            .map(enrich)
            .sort((a,b) => (b.date?.getTime?.() || 0) - (a.date?.getTime?.() || 0))
            .slice(0, 30)
        );
      } catch (err) {
        console.error("Error fetching alarms:", err?.message || err);
      } finally {
        if (alive) decBoot();
        setNewLoad(false)
      }
    })();

    return () => { alive = false; };
  }, [user?.idc, user?.idu, isSA, isUU, isAA, setNewLoad, newLoad]);
  // ------ Informacion de dato de rotacion ------//
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      if (width < 500) setChartSize({ prope: 80, inner: 35, outer:40 }) ;
      else if (width < 1800) setChartSize({ prope: 120, inner: 50, outer:60 });
      else setChartSize({ prope: 150, inner: 60, outer: 70 });
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  // ------ Data del equipo o usuarios ------//
  useEffect(() => {
    let isMounted = true;
    incBoot();
    const fetchUsers = async () => {
      try {
        // Guard 0: si no hay user aún
        if (!user) { if (isMounted) setLoad(false); return; }
        // Guard 1: si NO es SA y no hay idc, no dispares consultas inválidas
        if (!isSA && !user.idc) { if (isMounted) setLoad(false); return;}
        const baseCol = collection(db, "users");
        // ---- Filtros comunes por rol/compañía ----
        const scopeFilters = [];
        if (!isSA) scopeFilters.push(where("idc", "==", user.idc));
        // ---- Rango de tiempo (últimos 30 días) ----
        const now = new Date();
        const last30 = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
        const tsNow = Timestamp.fromDate(now);
        const ts30  = Timestamp.fromDate(last30);
        // ---- 1) LISTA para UI ----
        const qList = query(
            baseCol,
            ...scopeFilters,
            orderBy("fechaCreacion", "desc"),
            limit(200) // ajusta/pagina si hace falta
        );
        // ---- 2) CONTEO ACTIVOS ----
        const qActiveCount = query(
            baseCol,
            ...scopeFilters,
            where("status", "==", true)
        );
        // ---- 3) CONTEO CONECTADOS 30 DÍAS ----
        const qConn30 = query(
            baseCol,
            ...scopeFilters,
            where("status", "==", true),
            where("lastLogin", ">=", ts30),
            where("lastLogin", "<=", tsNow)
        );
        // ---- 4a) NUEVOS 30 DÍAS ----
        const qNew30 = query(
            baseCol,
            ...scopeFilters,
            where("fechaCreacion", ">=", ts30),
            where("fechaCreacion", "<=", tsNow)
        );
        // ---- 4b) SALIDAS 30 DÍAS ----
        const qLeft30 = query(
            baseCol,
            ...scopeFilters,
            where("fechaDelete", ">=", ts30),
            where("fechaDelete", "<=", tsNow)
        );
        // Ejecutar en paralelo
        const [snapList, activeCntSnap, connCntSnap, newCntSnap, leftCntSnap] = await Promise.all([
            getDocs(qList),
            getCountFromServer(qActiveCount),
            getCountFromServer(qConn30),
            getCountFromServer(qNew30),
            getCountFromServer(qLeft30),
        ]);
        // Mapear lista
        const list = snapList.docs.map(d => {
            const data = d.data();
            return {
              id: d.id,
              ...data,
              fechaCreacion: data.fechaCreacion?.toDate?.() || null,
              fechaDelete: data.fechaDelete?.toDate?.() || null,
              lastLogin: data.lastLogin?.toDate?.() || null,
            };
        });
        // Conteos
        const activeCount = activeCntSnap.data().count || 0;
        const connected30 = connCntSnap.data().count || 0;
        const new30 = newCntSnap.data().count || 0;
        const left30 = leftCntSnap.data().count || 0;
        // KPIs
        const startHeadcount = Math.max(activeCount - new30 + left30, 1);
        const turnoverRate = ((left30 / startHeadcount) * 100).toFixed(0);
        const continuidadParaGrafico = Math.max(startHeadcount - new30, 0);
        if (!isMounted) return;
        setUsers(list);
        setUsersCount(activeCount);
        setConnectedLast30Days(connected30);
        setMonth({
            datos: [
            { label: "Salidas", value: left30 },
            { label: "Continuidad", value: continuidadParaGrafico },
            { label: "Ingreso", value: new30 },
            ],
            porcentaje: turnoverRate,
        });
      } catch (err) {
        // Si falta índice, verás failed-precondition con link
        console.error("fetchUsers error:", err?.message || err);
      } finally {
        if (isMounted) setLoad(false);
      }
    };
    fetchUsers();
    setNewLoad(false)
    return () => { isMounted = false; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user.idc, user.rol, setNewLoad, newLoad]);
  // ----- Efecto: KPI de órdenes (count + latest por bucket) -----
  useEffect(() => {
    let alive = true;
    if (!user?.idc ) return; 
    incBoot();
    (async () => {
      // 🔄 Órdenes del usuario — independiente para que no se caiga por índices faltantes de KPIs
      if (user?.id) {
        try {
          const allOrdersQuery = query(collection(db, "orden"), where("idu", "==", user.id));
          const allOrdersSnap = await getDocs(allOrdersQuery);
          const allOrders = allOrdersSnap.docs.map(doc => ({
            id: doc.id,
            ...doc.data(),
          }));
          if (alive) {
            setUserOrders(allOrders);
            setUserOrdersLoaded(true);
          }
        } catch (err) {
          console.error("fetchUserOrders error:", err?.message || err);
          if (alive) setUserOrdersLoaded(true);
        }
      }

      try {
        const base = collection(db, "orden");
        const scope = [];
        if (isSA) scope.push();
        if (isAA) scope.push(where("idc", "==", user.idc));
        if (isUU) scope.push(where("idu", "==", user.id));

        const BUCKETS = {
          verif:  [0],
          prep:   [1, 2],
          route:  [3, 4, 5],
          deliv:  [6],
          pickup: [7, 8, 9, 10, 11, 12, 13, 14],
        };

        const getStats = async (statusIds) => {
          const qCount  = query(base, ...scope, where("order_status_id", "in", statusIds));
          const qLatest = query(base, ...scope, where("order_status_id", "in", statusIds), orderBy("creation","desc"), limit(1));
          const [countSnap, latestSnap] = await Promise.all([ getCountFromServer(qCount), getDocs(qLatest) ]);
          const count = countSnap.data().count || 0;
          const latestDoc = latestSnap.docs[0] || null;
          return { count, latest: latestDoc ? {
            id: latestDoc.id,
            ...latestDoc.data(),
            ...latestDoc.data()?.deleveryData,
            date: latestDoc.data()?.creation || null,
            creation: latestDoc.data()?.creation?.toDate?.() || null,
          } : null };
        };

        const [verif, prep, route, deliv, pickup] = await Promise.all([
          getStats(BUCKETS.verif),
          getStats(BUCKETS.prep),
          getStats(BUCKETS.route),
          getStats(BUCKETS.deliv),
          getStats(BUCKETS.pickup),
        ]);

        if (alive) setOrderKpis({ verif, prep, route, deliv, pickup });
      } catch (err) {
        console.error("fetchOrderKpis error:", err?.message || err);
      } finally {
        if (alive) decBoot();
        setNewLoad(false);
      }
    })();

    return () => { alive = false; };
  }, [user?.idc, isSA, isUU, user?.id, isAA, newLoad, setNewLoad]);
  // ------Data de kit asignados a usuarios -------//
  useEffect(() => {
    let alive = true;
    if (!user?.id) return;
    // Esperar a que userOrders haya cargado antes de calcular processed,
    // para evitar un flash donde todos los kits se marcan como "earring".
    if (!userOrdersLoaded) return;
    incBoot();
    (async () => {
      try {
        // Para US: agregar where("users","array-contains",user.id) para que
        // Firestore devuelva SOLO docs donde el uid ya está incluido. Sin
        // este filtro la regla de Firestore rechazaría docs del mismo idc
        // que no incluyan al US en users[], lanzando permission-denied.
        // Para AA/SA: la regla permite leer todos los docs del idc sin
        // necesidad de array-contains.
        const baseConstraints = [
          collection(db, "kit_application"),
          where("idc", "==", user.idc),
        ];
        if (!isAA && !isSA && user?.id) {
          baseConstraints.push(where("users", "array-contains", user.id));
        }
        const kitsSnapshot = await getDocs(query(...baseConstraints));
        const kitsData = [];
        kitsSnapshot.forEach(doc => {
          const data = doc.data();
          if (data.users.includes(user.id)) {
            // idk canónico: assignment.id (siempre presente) con fallback a idk (legacy)
            const kitIdk = data.assignment?.id || data.idk;
            const processed = userOrders.some(order => order.idk === kitIdk)
              ? "done"
              : "earring";
            kitsData.push({ id: doc.id, ...data, idk: kitIdk, processed });
          }
        });
        if (alive) {
          setUserAsingKit(kitsData);
          setUserAsingKitLoaded(true);
        }
      } catch (err) {
        console.error("Carga de kits:", err?.message || err);
        if (alive) setUserAsingKitLoaded(true);
      } finally {
        if (alive) decBoot();
      }
    })();
    return () => { alive = false; };
  }, [user?.idc, user?.id, userOrders, userOrdersLoaded]);
  // ------ Conteo de inventario ------//
  useEffect(() => {
    let alive = true;
    if (!user) return;
    if (!isSA && !user.idc) return;

    incBoot();
    (async () => {
      try {
        const baseCol = collection(db, "products-assignment");
        const baseConstraints = [];
        if (isSA) { baseConstraints.push(where("status", "==", true)); }
        if (isAA) { baseConstraints.push(where("idc", "==", user.idc), where("status", "==", true)); } 
        if (isUU) { baseConstraints.push(where("idc", "==", user.idc), where("status", "==", true), where("idu", "==", user.id));}
        const build = (...extra) => query(baseCol, ...baseConstraints, ...extra);

        const [rentalSnap, sSnap, eSnap, cSnap, ownSnap] = await Promise.all([
          getCountFromServer(build(where("stock_type", "==","rental"))),
          getCountFromServer(build(where("category", "==", "tBrwItGC8uUbSOhiBQXJ"))), // SILLAS
          getCountFromServer(build(where("category", "==", "l00z7GUbpol1VlgQXcDG"))), // ESCRITORIOS
          getCountFromServer(build(where("category", "==", "oKANbrQXHNeFdJWse0po"))), // LAPTOP
          getCountFromServer(build(where("stock_type", "==","own"))),
        ]);

        const totalRental  = rentalSnap.data().count || 0;
        const s = sSnap.data().count || 0;
        const e = eSnap.data().count || 0;
        const c = cSnap.data().count || 0;
        const external = ownSnap.data().count || 0;
        const others = Math.max(totalRental - s - e - c, 0);

        if (alive) {
          setSCount(s);
          setECount(e);
          setCCount(c);
          setACount(others);
          setOCoun(external);
        }
      } catch (err) {
        console.error("get category counts error:", err?.message || err);
        if (alive) { setSCount(0); setECount(0); setCCount(0); setACount(0); setOCoun(0); }
      } finally {
        if (alive) decBoot();
      }
    })();

    return () => { alive = false; };
  }, [user?.id, user?.idc, isSA, user?.rol]);
  // Refrescar manualmente desde cualquier parte
  const reloadUsers = useCallback(() => setShouldReload((n) => n + 1), []);
  // ÚNICA consulta centralizada de users
  useEffect(() => {
    let alive = true;
    incBoot();
    (async () => {
      try {
        // guards
        if (!user) return;
        if (!isSA && !user?.idc) return;
        const baseRef = collection(db, "users");
        const q = isSA ? query(baseRef) : query(baseRef, where("idc", "==", user.idc));
        const snap = await getDocs(q);

        let list = snap.docs.map((d) => {
          const data = d.data();
          return {
            id: d.id,
            ...data,
            date: data.fechaCreacion,
            fechaCreacion: toDate(data.fechaCreacion),
            fechaDelete: toDate(data.fechaDelete),
            lastLogin: toDate(data.lastLogin),
          };
        });

        const listuser = list;
        if (user?.id) list = list.filter((u) => u.id !== user.id);
        list.sort((a, b) => toMs(b.fechaCreacion) - toMs(a.fechaCreacion));

        if (alive) {
          setUsersList(list);
          setDataUsers(listuser)
          setError(null);
          setCurrentPage(1);
        }
      } catch (e) {
        if (alive) setError(e);
        console.error("Error fetching users (context):", e?.code || e?.message || e);
      } finally {
        if (alive) decBoot();
      }
    })();
    return () => { alive = false; };
  }, [user?.id, user?.idc, isSA, shouldReload, newLoad, setNewLoad]);
  // Unico llamado de companys si el usuario es superAdmin
  useEffect(() => {
    let alive = true;
    incBoot();
    (async () => {
        try {
          if (!isSA) return;
          const q = collection(db, 'company');
          const querySnapshot = await getDocs(q);
          const fetchedInfo = querySnapshot.docs.map(doc => ({
              id: doc.id,
              ...doc.data(),
          }));
          if (alive) setCompanys(fetchedInfo);
        } catch (e) {
          if (alive) setError(e);
          console.error("Error fetching company (context):", e?.code || e?.message || e);
        } finally {
          if (alive) decBoot();
        }
    })();
    return () => { alive= false; }
  }, [idItem, isSA]);
  // Valor del contexto (memo para evitar renders)
  const value = useMemo(
    () => ({
      toDate,
      toMs,
      idItem,
      setIdItem,
      route,
      setRoute,
      selectedIndex,
      setSelectedIndex,
      orderPictures,
      setOrderPictures,
      isModalOpen,
      setIsModalOpen,
      currentPage,
      setCurrentPage,
      setNewLoad,
      load,
      setLoad,
      error,
      usersList,
      setUsersList,
      users,
      usersCount,
      alarms,
      connectedLast30Days,
      tips,
      sCount,
      eCount,
      cCount,
      aCount,
      oCount,
      orderKpis,
      month, 
      chartSize,
      companys,
      dataUsers,
      setDataUsers,
      setUserOrders,
      userOrders,
      userOrdersLoaded,
      userAsingKit,
      userAsingKitLoaded,
      setUserAsingKit,
      reloadUsers,
      setIsRegisterOpen,
      isRegisterOpen
    }),
    [
      idItem, 
      route, 
      selectedIndex, 
      orderPictures, 
      isModalOpen, 
      currentPage, 
      load, 
      error, 
      usersList, 
      users, 
      usersCount, 
      alarms, 
      connectedLast30Days, 
      tips, 
      sCount, 
      eCount, 
      cCount, 
      aCount, 
      oCount, 
      orderKpis, 
      month, 
      chartSize, 
      companys,
      dataUsers,
      setNewLoad,
      setDataUsers,
      setUserOrders,
      userOrders,
      userOrdersLoaded,
      userAsingKit,
      userAsingKitLoaded,
      setUserAsingKit,
      reloadUsers,
      setIsRegisterOpen,
      isRegisterOpen
    ]
  );
  return <VariableContext.Provider value={value}>{children}</VariableContext.Provider>;
};

export const useIdContext = () => {
  const ctx = useContext(VariableContext);
  if (!ctx) throw new Error("useIdContext debe usarse dentro de <VariableProvider>.");
  return ctx;
};
